import React, { useEffect, useState } from "react";
import ProductList from "../../components/DynamicList&Grid/DynamicListGrid";
import { getStoredData } from "../../json/fecthData";
import { useApiData } from "../../components/ApiDataProvider/ApiDataProvider";
import "./UserManagement.css";

const UserManagement = () => {
  const userData = getStoredData()?.[1] || {}; // Extract user-related data (assuming it's at index 3)

  const { TitleUser, AdminUser, RedirectAdminUser, ApiUser } = userData;

  const { apiData, loading, error } = useApiData(["user"]); // Fetch user data from API
  const [user, setUser] = useState([]); // Initialize state for users

  useEffect(() => {
    if (apiData?.user && Array.isArray(apiData.user)) {
      setUser(apiData.user); // Ensure users is always an array
    } else {
      setUser([]); // Fallback to empty array
    }
  }, [apiData]);

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error.message}</p>;

  return (
    <div className="UserManagement">
      <h1>{TitleUser} Management</h1>

      {AdminUser && user.length > 0 ? (
        <ProductList
          products={user} // Pass user data dynamically from API
          fields={AdminUser} // Pass fields dynamically from configuration
          redirect={RedirectAdminUser} // Use redirect path for editing user
          deleteApi={ApiUser} // API endpoint for deletion
          showEdit={true} // Enable edit button
          showDelete={true} // Enable delete button
          createPath={`/${TitleUser?.toLowerCase()}/create`} // Dynamically generate create path
        />
      ) : (
        <p>No data available</p>
      )}
    </div>
  );
};

export default UserManagement;
